<template>
  <div class="">
    <section id="about-me" class="about-me">
      <div class="container">
        <div class="py-5">
          <div class="py-5">
            <h2>เกี่ยวกับเรา</h2>
          </div>
          <div class="row">
            <div class="col-md-8 col-12 col-xl-8">
              <p class="p1">
                มหาวิทยาลัยทักษิณ เป็นสถาบันอุดมศึกษาในพื้นที่ภาคใต้ ประกอบด้วย 2 วิทยาเขต ได้แก่
                วิทยาเขตสงขลาและวิทยาเขตพัทลุง เริ่มก่อตั้งเมื่อปี พ.ศ. 2511
                ในนามของวิทยาลัยวิชาการศึกษา สงขลา ในพื้นที่จังหวัดสงขลา
                ยกฐานะเป็นมหาวิทยาลัยศรีนครินทรวิโรฒ วิทยาเขตสงขลา
                สังกัดทบวงมหาวิทยาลัยโดยต่อมาเป็นส่วนหนึ่งของมหาวิทยาลัยศรีนครินทรวิโรฒ ในปี พ.ศ.
                2535 กำหนดชื่อใหม่เป็นมหาวิทยาลัยศรีนครินทรวิโรฒ วิทยาเขตภาคใต้ ปี พ.ศ. 2539
                ยกฐานะเป็นมหาวิทยาลัยทักษิณ ปี พ.ศ.2548 ขยายเป็น 2 วิทยาเขต คือ
                วิทยาเขตสงขลาและวิทยาเขตพัทลุง และในปี พ.ศ. 2551
                ได้เป็นสถานะเป็นมหาวิทยาลัยในกำกับของรัฐ
              </p>
            </div>
            <div class="col"></div>
          </div>
          <div class="row">
            <div class="col-xl-9 col-lg-11 col-md-12">
              <p>
                ภารกิจทุนการศึกษา ฝ่ายกิจการนิสิต เป็นภารกิจหนึ่งฝ่ายกิจการนิสิต
                ซึ่งมีหน้าที่ในการสนับสนุนการจัดสรรทุนการศึกษาให้แก่นิสิต
                เพื่อเป็นสวัสดิการในการดูแลนิสิตที่มีความต้องการปัจจัยทางการเงิน
                เพื่อส่งเสริมให้นิสิตสามารถดำเนินชีวิตได้อย่างเหมาะสมจนสำเร็จการศึกษา
              </p>
              <p>
                ในการพัฒนาระบบ TSU E-Donation มีหน่วยงานที่ร่วมพัฒนาระบบ ได้แก่ สำนักคอมพิวเตอร์
                ฝ่ายกิจการนิสิต ฝ่ายการคลังและทรัพย์สิน และฝ่ายสื่อสารองค์กร
                โดยมีวัตถุประสงค์เพื่อเพิ่มช่องทางและอำนวยความสะดวกแก่ผู้ที่มีความประสงค์จะบริจาคทุนการศึกษาแก่นิสิต
                ตลอดจนเป็นช่องทางในการจัดกิจกรรมระดมทุนในโอกาสต่างๆ ของมหาวิทยาลัยหรือส่วนงานต่างๆ
                เช่น การระดมทุนการศึกษาในวาระครบ 55 ปี มหาวิทยาลัยทักษิณ
                การบริจาคช่วยเหลือผู้ประสบภัยต่างๆ เป็นต้น
              </p>
            </div>
            <div class="col"></div>
          </div>
        </div>
        <div>
          <div class="text-center">
            <h4>ชื่อหน่วยรับบริจาค: มหาวิทยาลัยทักษิณ</h4>
          </div>
          <div class="row justify-content-around">
            <div class="col-5 my-tax" style="background-color: #c9dcfe">
              <div><span>เลขประจำตัวหน่วยรับบริจาค:</span> 0994000580070</div>
              <div><span>ประเภทหน่วยบริจาค:</span> สถานศึกษา</div>
              <div>
                <span>ที่อยู่หน่วยรับบริจาค</span>
                <div class="campus-address">
                  วิทยาเขตสงขลา 140 ถ.กาญจนวนิช ม.4 ต.เขารูปช้าง อ.เมือง จ.สงจลา 90000
                </div>
              </div>
            </div>
            <div class="col-5 my-tax" style="background-color: #f68920">
              <div><span>เลขประจำตัวหน่วยรับบริจาค:</span> 0994000629800</div>
              <div><span>ประเภทหน่วยบริจาค:</span> สถานศึกษา</div>
              <div>
                <span>ที่อยู่หน่วยรับบริจาค</span>
                <div class="campus-address">
                  วิทยาเขตพัทลุง 222 หมู่ 2 ต.บ้านพร้าว อ.ป่าพะยอม จ.พัทลุง 93210
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
</script>

<style scoped>
.my-tax {
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
}
.about-me {
  width: 100%;
  background-image: url('../assets/images/about-me/about-hero.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  padding: 0;
}
.campus-address {
  text-indent: 30px;
}
p {
  text-indent: 50px;
  background-color: #ffffff80;
}
</style>